export default "__VITE_ASSET__DBLv$DlI__"